const prodKeys = {
  apiKey: 'AIzaSyDGuYqOH1zTx9bkP-mmy7m1avxs0mhcaVg',
  clientId: '932811756359-ukc316o6ucugslhgll1odv64r9iiessk.apps.googleusercontent.com',
  projectId: 'bbcenter',
  subscriptionId: 'bb-email-subscription',
  topicId: 'bb-email'
}

const prodConsultantsKeys = {
  apiKey: 'AIzaSyALJ8RJhU_qlumdlMKI4_xsuyn6DuBFrZ8',
  clientId: '303784876873-6m8kujujrhrt271br5nu7db7am2k39j2.apps.googleusercontent.com',
  projectId: 'bbcenter-285011',
  subscriptionId: 'bb-email-subscription',
  topicId: 'bb-email'
}

const stgKeys = {
  apiKey: 'AIzaSyDP86ZtopegmjR3E57CGglSkajFM1Qd8Ug',
  clientId: '637625514178-d9crqsva63pu0r6fcconi2qug9b4v7b8.apps.googleusercontent.com',
  projectId: 'impactfactors.net:api-project-637625514178',
  subscriptionId: '',
  topicId: ''
}

const localKeys = {
  apiKey: 'AIzaSyDa7urKTHJkFQ3M_Rd0LW6LUZ-_WqJXNa8',
  clientId: '707703091445-ufrft7ah0j0lmrd1n2d0nakqrgf6ev54.apps.googleusercontent.com',
  projectId: 'emailtest-270808',
  subscriptionId: 'emailtest',
  topicId: 'emailtest-270808'
}

const keysGapi = {
  local: localKeys,
  stg: stgKeys,
  prod: prodKeys,
  prodConsultants: prodConsultantsKeys
}

export default keysGapi



// WEBPACK FOOTER //
// ./src/constants/googleApi/keysGapi.js